import React from "react";

import {
  CloseButton,
  SubmitButton,
  UpdateButton,
} from "../../../Component/ActionButton";

export default function ProductSizeModal(props) {
  const { actionData } = props;
  console.log(actionData);
  const [data, setData] = React.useState(actionData || {});
  console.log(data);

  const formDataHandler = (e) => {
    const { name, value } = e.target;
    setData(() => ({
      ...data,
      [name]: value,
    }));
  };
  return (
    <div
      className="modal fade"
      id="productSizeModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">
              Product Size
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body">
            <div className="d-flex gap-4 justify-content-center align-items-center w-100">
              <div className="flex-1">
                <label htmlFor="name" className="col-form-label">
                  name:
                </label>
                <input
                  required
                  name="name"
                  value={data?.name}
                  onChange={formDataHandler}
                  className="form-control"
                  id="name"
                />
              </div>

              <div className="flex-1">
                <label htmlFor="sizeInGB" className="col-form-label">
                  Size In GB:
                </label>
                <input
                  name="sizeInGB"
                  value={data?.sizeInGB}
                  type="number"
                  onChange={formDataHandler}
                  className="form-control"
                  id="sizeInGB"
                />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            {!data?.id && (
              <SubmitButton
                endPoint={`/Main?objectName=AvailableDiskSizes`}
                data={data}
                setData={setData}
              />
            )}
            <CloseButton />
            {data?.id && (
              <UpdateButton
                endPoint={`/Main/${data?.id}?objectName=AvailableDiskSizes`}
                data={data}
                setData={setData}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
